import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BrokerFeatureDTO} from '../../../pbm/models/BrokerFeatureDTO';
import {NameValueCodeDTO} from '../../models/NameValueCodeDTO';
import {CreateNameValueDTO} from '../../models/NameValueDTO';
import {AccessLevel} from '../../types/feature';

export interface BrokerPermissionDialogData {
  availableFeatures: NameValueCodeDTO[];
  brokerFeatures: BrokerFeatureDTO[];
  brokerId: number;
  canManageFeatures: boolean;
}

@Component({
  selector: 'greydom-manage-broker-permissions-dialog',
  templateUrl: './manage-broker-permissions-dialog.component.html',
  styleUrls: ['../../../../../styles/global/_dialog-styles.scss']
})
export class ManageBrokerPermissionsDialogComponent implements OnInit {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ManageBrokerPermissionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BrokerPermissionDialogData) {
  }

  ngOnInit(): void {
    const group = {};
    this.data.availableFeatures.forEach(availableFeature => {
      const hasFeature = this.data.brokerFeatures.some(
        brokerFeature =>
          brokerFeature.feature.value === availableFeature.value &&
          brokerFeature.accessLevel.value === AccessLevel.Allow
      );
      group[availableFeature.name] = hasFeature;
    });
    this.form = this.fb.group(group);
  }

  toggleFeature(name: string, allowed: boolean): void {
    this.form.get(name)?.setValue(allowed);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    const result: BrokerFeatureDTO[] = [];
    this.data.availableFeatures.forEach(feature => {
      const isAllowed = !!this.form.get(feature.name)?.value;
      result.push({
        brokerId: this.data.brokerId,
        featureId: feature.value,
        feature,
        accessLevel: isAllowed ? CreateNameValueDTO(AccessLevel.Allow, 'allow') : CreateNameValueDTO(AccessLevel.Deny, 'deny'),
        isInherited: false
      });
    });
    this.dialogRef.close(result);
  }
}
